import { I00RELGAZPUISS_State } from '@batical/types/src'

const I00RELGAZPUISS: I00RELGAZPUISS_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  in_pci: 10.4,
  gaz_uuid: '7E3D48EC-7E15-4FB7-AE58-0D558DFBA0B3',
  in_pressionGaz: 200.0,
  in_debitCompteur: 20.0,
  in_temperatureGaz: 15.0,
  in_pressionAtmospherique: 1013.0,
  res_puisanceChaudiere: 0.0,
  mode: 'none',
  calcul_code: 'I00RELGAZPUISS'
}

export default I00RELGAZPUISS
